import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

import { KYMW5002ImageInfoDetailBoxComponent } from '../kymw5002-image-info-detail-box/kymw5002-image-info-detail-box.component';

/**
 * EC使用画像指示画面を管理するクラス
 *
 * @export KYMW5002ImageInfoDetailComponent
 * @class KYMW5002ImageInfoDetailComponent
 */
@Component({
  selector: 'app-kymw5002-image-info-detail',
  templateUrl: 'kymw5002-image-info-detail.component.html',
  styleUrls: ['kymw5002-image-info-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5002ImageInfoDetailComponent implements OnInit {
  @ViewChild('imageInfoDetailBox', { static: true }) imageInfoDetailBox: KYMW5002ImageInfoDetailBoxComponent;

  @Input() goodsImagePreviewURL = String('');

  @Output() eventImageInfoDetailCHANGE: EventEmitter<any> = new EventEmitter;
  @Output() changeEndOrderCode2: EventEmitter<any> = new EventEmitter;
  @Output() eventSettingCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventResetCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseStopCLICK: EventEmitter<any> = new EventEmitter;

  // ボタン非活性フラグ
  public disabledSettingBtn = Boolean(false);
  public disabledResetBtn = Boolean(false);
  public disabledUseStopBtn = Boolean(false);

  /**
   *Creates an instance of KYMW5002ImageInfoDetailComponent.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @memberof KYMW5002ImageInfoDetailComponent
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
  }
}
